import {Pipe, PipeTransform} from "@angular/core";
import {SimSessionService} from "@services";
import {from, Observable} from "rxjs";
import {TrainingSession} from "@models";

@Pipe({
	name: "getTrainingSessionbyId",
	standalone: false,
})
export class GetTrainingSessionbyIdPipe implements PipeTransform {
	constructor(private _simSessionService: SimSessionService) {}

	transform(value: string, ...args: unknown[]): Observable<TrainingSession> {
		return from(this._simSessionService.getSessionById(value)) as Observable<TrainingSession>;
	}
}
